// extracted by mini-css-extract-plugin
export default {"text":"index-module_text_X4Y02"};